<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Gestion des utilisateurs</h1>
    </div>
    <div class="row">
      <div class="col mt-4 mt-xl-0 order-1 order-xl-0">
        <div class="row mb-2">
          <div class="col">
            <button class="btn btn-success btn-sm" @click="ResetNew">Creer</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <MyVuetable ref="vuetable" @detailsRow="detailsRow" url="users" :fields="fields" :sortOrder="sortOrder"></MyVuetable>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-4 border order-xl-12 order-0" v-if="idInt || showEditor">
        <UsersEditor :id="id" @onUpdate="onUpdate" @onDelete="onDelete"></UsersEditor>
      </div>
    </div>
    </main>
  </div>
</template>

<script>
/* global $ */
import MyVuetable from '@/components/MyVuetable'
import UsersEditor from '@/components/UsersEditor'

export default {
  components: {
    MyVuetable,
    UsersEditor
  },
  props: {
    id: String,
    showEditor: Boolean
  },
  data () {
    return {
      fields: [
        {
          name: 'login',
          sortField: 'login',
          title: 'Login'
        },
        {
          name: 'nom',
          sortField: 'nom',
          title: 'Nom'
        },
        {
          name: 'profile',
          sortField: 'profile',
          title: 'Profile'
        },
        '__slot:details'
      ],
      sortOrder: [
        {
          field: 'profile',
          direction: 'asc'
        },
        {
          field: 'login',
          direction: 'asc'
        }
      ]
    }
  },
  computed: {
    idInt() {
      if(!isNaN(parseInt(this.id))) {
        return parseInt(this.id)
      }

      return null
    }
  },
  methods: {
    ResetNew(){
      this.$router.replace( { name:'usersManagerNew' }).catch(() => {})
    },
    detailsRow(rowData) {
      this.$router.replace({name:'usersManager',params: { id: rowData.id }}).catch(() => {})
    },
    onUpdate() {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    },
    onDelete() {
      this.$router.push({ name:'usersManager' }).catch(() => {})
    }
  },
  watch:
  {
    id () {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    }
  }
}
</script>
